import { useContext } from "react";
import { PageBuilderContext } from "../context/PageBuilderContext";
import { PageBuilderCtx } from "../types/page-builder.types";

export function usePageBuilder(): PageBuilderCtx {
  const ctx = useContext(PageBuilderContext);
  if (!ctx) throw new Error("usePageBuilder must be used within PageBuilderProvider");
  return ctx;
}
